export const appVersion = '2.6.9';

export const siteAssetsBaseUrl = 'https://static-s.sheyda.com/site-assets';

export const staticImages = {
  logo: `${siteAssetsBaseUrl}/logo.svg`,
  miniLogoWhite: `${siteAssetsBaseUrl}/mini-logo-white.svg`,
};

export enum Variables {
  accessToken = 'tvatk',
  refreshToken = 'tvrtk',
  did = 'tvdid',
  temptToken = 'tvtmt',
}
